import React from 'react';
import ReactDOM from 'react-dom';
// containers
import { AuthenticationContainer } from 'src/app/containers';
// progressive Web app
import * as serviceWorker from './serviceWorker';
// app global styles
import './styles/styles.scss';

const container = document.getElementById('root');
ReactDOM.render(<AuthenticationContainer />, container);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
